// @flow
import React from 'react';
import { languages } from '../../../../constants';

type Props = {
    lng: string,
    handleLanguage: Functiuon,
};

const Languages = ({ lng, handleLanguage }: Props) => (
    <div>
        <input type="checkbox" className="ipx-checkhid" id="ipx-languagedrop" />
        <label htmlFor="ipx-languagedrop" id="languages">
            {languages.map(lang => (
                <div key={lang}>
                    <input
                        type="radio"
                        className="ipx-checkhid"
                        name="langue"
                        value={lang}
                        id={`langue-${lang}`}
                        onChange={() => handleLanguage(lang)}
                        checked={lng === lang && 'checked'}
                    />
                    <label htmlFor={`langue-${lang}`}>
                        <i className={`lang-${lang}`} />
                        {lang}
                    </label>
                </div>
            ))}
            <i className="expand x" />
            <i className="expand y" />
        </label>
    </div>
);

export default Languages;



// WEBPACK FOOTER //
// ./src/ui/components/Modal/Footer/Languages.js